/**
 * Currency options for dropdowns.
 *
 * IMPORTANT: This must stay in sync with CURRENCY_CHOICES in apps/crm_events/core/currency.py.
 * When adding a new currency:
 * 1. Add it to CURRENCY_CHOICES in apps/crm_events/core/currency.py
 * 2. Run migrations
 * 3. Regenerate the API client: make build-api-client (updates DefaultCurrencyEnum)
 * 4. Add the option here with `value`, `label`, `symbol`, and `name`
 */
export const CURRENCY_OPTIONS = [
  { value: 'USD', label: 'USD - US Dollar', symbol: '$', name: 'US Dollar' },
  { value: 'EUR', label: 'EUR - Euro', symbol: '€', name: 'Euro' },
  {
    value: 'GBP',
    label: 'GBP - British Pound',
    symbol: '£',
    name: 'British Pound',
  },
  {
    value: 'AUD',
    label: 'AUD - Australian Dollar',
    symbol: 'A$',
    name: 'Australian Dollar',
  },
  {
    value: 'BRL',
    label: 'BRL - Brazilian Real',
    symbol: 'R$',
    name: 'Brazilian Real',
  },
  {
    value: 'CAD',
    label: 'CAD - Canadian Dollar',
    symbol: 'C$',
    name: 'Canadian Dollar',
  },
  {
    value: 'CHF',
    label: 'CHF - Swiss Franc',
    symbol: 'CHF',
    name: 'Swiss Franc',
  },
  {
    value: 'CNY',
    label: 'CNY - Chinese Yuan',
    symbol: '¥',
    name: 'Chinese Yuan',
  },
  {
    value: 'CZK',
    label: 'CZK - Czech Koruna',
    symbol: 'Kč',
    name: 'Czech Koruna',
  },
  {
    value: 'DKK',
    label: 'DKK - Danish Krone',
    symbol: 'kr',
    name: 'Danish Krone',
  },
  {
    value: 'HKD',
    label: 'HKD - Hong Kong Dollar',
    symbol: 'HK$',
    name: 'Hong Kong Dollar',
  },
  {
    value: 'HUF',
    label: 'HUF - Hungarian Forint',
    symbol: 'Ft',
    name: 'Hungarian Forint',
  },
  {
    value: 'IDR',
    label: 'IDR - Indonesian Rupiah',
    symbol: 'Rp',
    name: 'Indonesian Rupiah',
  },
  {
    value: 'ILS',
    label: 'ILS - Israeli Shekel',
    symbol: '₪',
    name: 'Israeli Shekel',
  },
  {
    value: 'INR',
    label: 'INR - Indian Rupee',
    symbol: '₹',
    name: 'Indian Rupee',
  },
  {
    value: 'ISK',
    label: 'ISK - Icelandic Krona',
    symbol: 'kr',
    name: 'Icelandic Krona',
  },
  {
    value: 'JPY',
    label: 'JPY - Japanese Yen',
    symbol: '¥',
    name: 'Japanese Yen',
  },
  {
    value: 'KRW',
    label: 'KRW - South Korean Won',
    symbol: '₩',
    name: 'South Korean Won',
  },
  {
    value: 'MXN',
    label: 'MXN - Mexican Peso',
    symbol: 'MX$',
    name: 'Mexican Peso',
  },
  {
    value: 'MYR',
    label: 'MYR - Malaysian Ringgit',
    symbol: 'RM',
    name: 'Malaysian Ringgit',
  },
  {
    value: 'NOK',
    label: 'NOK - Norwegian Krone',
    symbol: 'kr',
    name: 'Norwegian Krone',
  },
  {
    value: 'NZD',
    label: 'NZD - New Zealand Dollar',
    symbol: 'NZ$',
    name: 'New Zealand Dollar',
  },
  {
    value: 'PHP',
    label: 'PHP - Philippine Peso',
    symbol: '₱',
    name: 'Philippine Peso',
  },
  {
    value: 'PLN',
    label: 'PLN - Polish Zloty',
    symbol: 'zł',
    name: 'Polish Zloty',
  },
  {
    value: 'RON',
    label: 'RON - Romanian Leu',
    symbol: 'lei',
    name: 'Romanian Leu',
  },
  {
    value: 'SEK',
    label: 'SEK - Swedish Krona',
    symbol: 'kr',
    name: 'Swedish Krona',
  },
  {
    value: 'SGD',
    label: 'SGD - Singapore Dollar',
    symbol: 'S$',
    name: 'Singapore Dollar',
  },
  { value: 'THB', label: 'THB - Thai Baht', symbol: '฿', name: 'Thai Baht' },
  {
    value: 'TRY',
    label: 'TRY - Turkish Lira',
    symbol: '₺',
    name: 'Turkish Lira',
  },
  {
    value: 'ZAR',
    label: 'ZAR - South African Rand',
    symbol: 'R',
    name: 'South African Rand',
  },
] as const;
